import { create } from "zustand";

interface HookProps {
  open: boolean;
  leaveId: string;
  setLeaveId: (id: string) => void;
  onOpenChange: (open: boolean) => void;
}

export const useDeleteLeaveApplicationModal = create<HookProps>()((set) => ({
  open: false,
  leaveId: "",
  setLeaveId: (id) =>
    set(() => ({
      leaveId: id,
    })),
  onOpenChange: (open) =>
    set(() => ({
      open,
    })),
}));
